var _ellipse, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path0, _path1, _rect0, _rect1, _rect10, _rect11, _ellipse2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 278,
    viewBox: "0 0 186 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 81.5,
    cy: 272,
    rx: 81.5,
    ry: 6,
    fill: "url(#paint0_radial)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 79C30.7157 79 24 85.7157 24 94V238C24 246.284 30.7157 253 39 253H129C137.284 253 144 246.284 144 238V94C144 85.7157 137.284 79 129 79H39ZM103.5 90H64.5C59.8056 90 56 93.8056 56 98.5C56 103.194 59.8056 107 64.5 107H103.5C108.194 107 112 103.194 112 98.5C112 93.8056 108.194 90 103.5 90Z",
    fill: "#F5F8FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 120,
    width: 66,
    height: 66,
    rx: 33,
    fill: "#E2EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 186C102.225 186 117 171.225 117 153C117 134.775 102.225 120 84 120C65.7746 120 51 134.775 51 153C51 171.225 65.7746 186 84 186Z",
    fill: "#F2F6FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9241 153.564C76.9241 153.564 77.2998 157.822 77.2998 160.076C77.2998 162.33 75.6304 163.874 73.6679 164.71L78.4269 173.852H92.704L95.5844 165.211C93.6971 164.588 92.203 162.956 92.203 160.953V153.313L76.9241 153.564Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.203 160.953V154.907L77.0067 154.559C77.0205 154.741 77.0367 154.941 77.053 155.158C78.1313 157.178 82.2754 163.583 91.4515 163.583C91.9713 163.583 92.5273 163.494 93.0183 163.382C92.5085 162.687 92.203 161.858 92.203 160.953Z",
    fill: "#CEDBE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5464 151.059C75.5464 151.059 77.425 160.076 84.6888 160.076C92.203 160.076 93.7058 151.56 93.7058 151.56C93.7058 151.56 93.9563 152.311 94.5825 152.311C95.2087 152.311 97.0872 149.556 97.0872 145.799C97.0872 144.421 96.461 143.545 95.8349 143.545C95.2087 143.545 94.4573 145.298 94.4573 145.298L93.5806 137.283L76.0474 135.404L75.0455 145.298C75.0455 145.298 74.1688 143.419 73.4174 143.419C72.666 143.419 72.165 144.672 72.165 146.425C72.165 148.178 73.6679 152.186 74.6698 152.186C75.6717 152.186 75.5464 151.059 75.5464 151.059Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7931 144.296C74.2941 144.296 74.5446 145.298 74.5446 146.049C74.5446 146.801 73.7931 147.051 73.7931 147.928C73.7931 148.805 74.4193 148.679 74.4193 149.806C74.4193 150.433 74.2941 150.558 74.1688 150.558C74.0436 150.558 72.9165 148.93 72.9165 146.926C72.9165 144.922 73.2922 144.296 73.7931 144.296Z",
    fill: "#CEDBE3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4592 144.547C94.9582 144.547 94.7077 145.548 94.7077 146.3C94.7077 147.051 95.4592 147.302 95.4592 148.178C95.4592 149.055 94.833 148.93 94.833 150.057C94.833 150.683 94.9582 150.808 95.0834 150.808C95.2087 150.808 96.3358 149.18 96.3358 147.176C96.3358 145.173 95.9601 144.547 95.4592 144.547Z",
    fill: "#CEDBE3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6888 127.639C92.4535 127.639 96.5275 132.246 96.2106 138.285V143.65C95.6208 143.234 95.0372 144.025 94.4573 145.298C94.4573 145.298 93.3928 138.598 92.704 138.285C92.0152 137.972 78.2391 136.093 77.6755 136.156C77.112 136.218 76.6937 136.526 76.5484 137.032L75.0456 145.298C74.3605 143.959 73.7256 143.208 73.177 143.466C72.9604 141.97 72.666 140.915 72.666 138.159C72.666 135.404 73.0418 127.639 84.6888 127.639Z",
    fill: "#DEE5F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.277 171.576C109.386 170.454 107.495 169.489 105.604 168.717C101.052 167.06 96.7768 165.446 94.0817 164.083C94.0817 164.083 92.3284 171.097 84.0627 171.097C75.7971 171.097 74.169 163.958 74.169 163.958C69.5089 165.318 65.1569 166.777 61.1443 168.342C59.3622 169.151 57.798 170.079 56.4079 171.104C62.3065 180.075 72.4608 186 84.0001 186C95.3366 186 105.336 180.283 111.277 171.576Z",
    fill: "#DEE5F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 220,
    width: 17,
    height: 5,
    rx: 2.5,
    fill: "#C4CFE0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 220,
    width: 24,
    height: 5,
    rx: 2.5,
    fill: "#C4CFE0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 220,
    width: 33,
    height: 5,
    rx: 2.5,
    fill: "#C4CFE0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 209,
    width: 45,
    height: 5,
    rx: 2.5,
    fill: "#C4CFE0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 209,
    width: 11,
    height: 5,
    rx: 2.5,
    fill: "#C4CFE0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 209,
    width: 17,
    height: 5,
    rx: 2.5,
    fill: "#C4CFE0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 199,
    width: 30,
    height: 5,
    rx: 2.5,
    fill: "#C4CFE0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 199,
    width: 21,
    height: 5,
    rx: 2.5,
    fill: "#C4CFE0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 0H100.5L69 70.5H97L128.5 0Z",
    fill: "url(#paint1_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39 0H67L98.5 70.5H70.5L39 0Z",
    fill: "url(#paint2_linear)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 79,
    width: 40,
    height: 11,
    fill: "url(#paint3_linear)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 64,
    width: 32,
    height: 36,
    rx: 6,
    fill: "#9CB0BC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 65,
    width: 30,
    height: 19,
    rx: 5,
    fill: "url(#paint4_linear)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 80,
    width: 30,
    height: 19,
    rx: 5,
    fill: "url(#paint5_linear)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.5,
    cy: 274,
    rx: 44.5,
    ry: 3,
    fill: "url(#paint6_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.5 165C127.521 165 117 175.521 117 188.5V229.5C117 242.479 127.521 253 140.5 253C153.479 253 166 242.479 166 229.5V188.5C166 175.521 153.479 165 140.5 165ZM154 230.5V188.5C154 181.044 147.956 175 140.5 175C133.044 175 127 181.044 127 188.5V230.5C127 237.956 133.044 244 140.5 244C147.956 244 154 237.956 154 230.5Z",
    fill: "#D0DCE2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.5 166C129.521 166 119 176.521 119 189.5V230.5C119 243.479 129.521 254 142.5 254C155.479 254 166 243.479 166 230.5V189.5C166 176.521 155.479 166 142.5 166ZM156 231.5V189.5C156 182.044 149.956 176 142.5 176C135.044 176 129 182.044 129 189.5V231.5C129 238.956 135.044 245 142.5 245C149.956 245 156 238.956 156 231.5Z",
    fill: "#9DB1BD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106 212C106 209.239 108.239 207 111 207H172C174.761 207 177 209.239 177 212V263.655C177 266.147 175.165 268.258 172.697 268.606L142.197 272.902C141.735 272.967 141.265 272.967 140.803 272.902L110.303 268.606C107.835 268.258 106 266.147 106 263.655V212Z",
    fill: "#B4D1FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106 212C106 209.239 108.239 207 111 207H141.5V273L110.303 268.606C107.835 268.258 106 266.147 106 263.655V212Z",
    fill: "#CEE1FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133 236C133 231.029 137.029 227 142 227C146.971 227 151 231.029 151 236C151 240.971 146.971 245 142 245C137.029 245 133 240.971 133 236Z",
    fill: "#CEE1FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M137 234H147L149 257H135L137 234Z",
    fill: "#CEE1FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134 236C134 231.582 137.582 228 142 228C146.418 228 150 231.582 150 236C150 240.418 146.418 244 142 244C137.582 244 134 240.418 134 236Z",
    fill: "#405764"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138 235H146L148 256H136L138 235Z",
    fill: "#405764"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.5 272) rotate(90) scale(6 81.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAC9",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#61799F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 113.5,
    y1: 1.93627e-9,
    x2: 82,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#B7D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79A0DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 52.5,
    y1: 1.52792e-7,
    x2: 85.5,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 104,
    y1: 84,
    x2: 64,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#415B83",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#415B83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#415B83",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 84,
    y1: 65,
    x2: 84,
    y2: 72.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 84,
    y1: 98.1364,
    x2: 84,
    y2: 87.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#718592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CB0BC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.5 274) rotate(90) scale(3 44.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAC9",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#61799F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.646ea6c77cbff574cfbde20e41b6191a.svg";
export { ForwardRef as ReactComponent };